import { Image, Stack, Text, useColorModeValue,Center } from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useGetState } from "../../context/useGetState";
import Fancybox from "../dashboard/discover/stories/Fancybox";
import Microlink from '@microlink/react'

var relativeTime = require("dayjs/plugin/relativeTime");
let utc = require("dayjs/plugin/utc");

dayjs.extend(utc);
dayjs.extend(relativeTime);
function convertToTimeAgo(message_date) {
  // Parse the ISO 8601 date string to a Date object
  const createdAtDate = new Date(message_date);

  // Format the date to "4:38 am" format using dayjs
  const formattedTime = dayjs(createdAtDate).format("h:mm A");

  return formattedTime;
}
function convertToTime(message_date) {
  // Parse the ISO 8601 date string to a Date object
  const createdAtDate = new Date(message_date);

  // Format the date to "4:38 am" format using dayjs
  const formattedTime =
    createdAtDate.getDate() +
    "/" +
    (createdAtDate.getMonth() + 1) +
    "/" +
    createdAtDate.getFullYear();
       

  return formattedTime;
}

//check if string is url
function checkSTring(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    var _string=pattern.test(str)
    console.log('str test-->',_string)
  // return !!pattern.test(str);
  return _string? <Microlink url={str}    style={{ width: '400px' }}/>:str
}
export const ChatFeed = ({ message, chatContext, key, ...props }) => {
  const fromUserBg = useColorModeValue("#fff", "#3B4959");
  const toUserBg = useColorModeValue("#AFBBC6", "#243C50");
  const { state } = useGetState();
  const loggedInUser = state?.userInfo

  
  
  const ref = useRef(null);
  const fromUserStyle = {
    color: "#7B8793",
    bg: fromUserBg,
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px",
  };
  const toUserStyle = {
    color: "#fff",
    bg: toUserBg,
    borderTopLeftRadius: " 8px",
    borderBottomRightRadius: "8px",
    borderBottomLeftRadius: "8px",
  };

  const [sender, setSender] = useState({});
  useEffect(() => {
    ref.current?.scrollIntoView({ behaviour: "smooth" });
  }, [message]);

  return (
    <Stack
      ref={ref}
      direction={message?.sender_id == loggedInUser?.id ? "row-reverse" : "row"}
      alignItems="flex-start"
      alignSelf={
        message?.sender_id == loggedInUser?.id ? "flex-end" : "flex-start"
      }
    >
      <Stack alignItems={"flex-start"}>
        {message?.message !== "null" ? (
          <div id="message">

            <Text
              whiteSpace="pre-wrap"
              p="10px"
              fontSize={["1.4em", ".8em", ".8em", ".8em"]}
              maxW="300px"
              {...(message?.sender_id == loggedInUser?.id
                ? toUserStyle
                : fromUserStyle)}
            >
            {checkSTring(message?.message)}
            </Text>
          </div>
        ) : (
          <Fancybox
            options={{
              Carousel: {
                infinite: false,
              },
            }}
          >
            <a data-fancybox="gallery" href={message?.file}>
              <Image
                src={message?.file}
                maxW="150px"
                maxH="150px"
                borderRadius={"5px"}
                objectFit={"contain"}
              />
            </a>
          </Fancybox>
        )}
        <Text fontSize={[".9em", ".7em", ".7em", ".7em"]} color="#AFBBC6">
          {convertToTimeAgo(message?.created_at)}
        </Text>
      </Stack>
    </Stack>
  );
};
